import React from 'react';
import { XMarkIcon, UserIcon } from '@heroicons/react/24/outline';

const ETHNICITY_OPTIONS = [
  'White British',
  'White Irish',
  'Asian British',
  'Indian',
  'Pakistani',
  'Bangladeshi',
  'Chinese',
  'Black British',
  'Black African',
  'Black Caribbean',
  'Mixed White/Black Caribbean',
  'Mixed White/Black African',
  'Mixed White/Asian',
  'Other'
];

const DISABILITY_OPTIONS = [
  'ADHD',
  'Acquired Brain Injury',
  'Asthma',
  'Autism',
  'Cancer',
  'Cerebral Palsy',
  'Chronic Obstructive Airways Disease',
  'Communication Needs',
  'Cystic Fibrosis',
  'Diabetes',
  'Downs Syndrome',
  'Duel Sensory Loss (deafblind)',
  'Dyslexia',
  'Dysphagia',
  'Dyspraxia',
  'Epilepsy',
  'Global Developmental Delay',
  'Hearing Impairment',
  'Learning Disability',
  'Physical Disability',
  'Visual Impairment',
  'Hearing Impairment',
  'Speech and Language',
  'Mental Health',
  'Multiple Disabilities',
  'Other'
];

const EDUCATION_STATUS = [
  'Mainstream',
  'Mainstream with support (Additional Resource Provision)',
  'Special',
  'Home Schooled',
  'College',
  'Private School',
  'Independent School'
];

const INTERESTS = [
  'Arts and crafts',
  'Holiday activities and clubs',
  'Libraries',
  'Museums and galleries',
  'Music, dance, drama',
  'Parks and playgrounds',
  'Respite services',
  'Overnight respite',
  'Sports and exercise',
  'Youth Clubs',
  'Online activities',
  'Parents and carers',
  'Young carers'
];

const ProfileForm = ({ profile, onChange, onRemove, index, isChild = false, errors = {}, isModal = false }) => {
  // console.log('ProfileForm Errors:', errors);
  
  const handleInterestToggle = (interest) => {
    const currentInterests = profile.interests || [];
    const newInterests = currentInterests.includes(interest)
      ? currentInterests.filter(i => i !== interest)
      : [...currentInterests, interest];
    
    onChange({ target: { name: 'interests', value: newInterests } });
  };

  return (
    <div className={`p-4 ${!isModal && 'bg-gray-50'} rounded-lg`}>
      {index !== undefined && (
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-sm font-medium text-gray-900">Child {index + 1}</h4>
          <button
            type="button"
            onClick={onRemove}
            className="text-gray-400 hover:text-red-500"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      )}

      {isChild && (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-700">First Name</label>
            <div className="relative">
              <input
                type="text"
                name="firstName"
                value={profile.firstName || ''}
                onChange={onChange}
                className={`pl-10 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 ${
                  errors.firstName ? 'border-red-300' : ''
                }`}
                placeholder="John"
              />
              <UserIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
            </div>
            {errors.firstName && <p className="text-xs text-red-600 mt-1">{errors.firstName}</p>}
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700">Last Name</label>
            <div className="relative">
              <input
                type="text"
                name="lastName"
                value={profile.lastName || ''}
                onChange={onChange}
                className={`pl-10 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 ${
                  errors.lastName ? 'border-red-300' : ''
                }`}
                placeholder="Doe"
              />
              <UserIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
            </div>
            {errors.lastName && <p className="text-xs text-red-600 mt-1">{errors.lastName}</p>}
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-700">Date of Birth</label>
          <input
            type="date"
            name="dateOfBirth"
            value={profile.dateOfBirth || ''}
            onChange={onChange}
            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 ${
              errors.dateOfBirth ? 'border-red-300' : ''
            }`}
          />
          {errors.dateOfBirth && <p className="text-xs text-red-600 mt-1">{errors.dateOfBirth}</p>}
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700">Gender</label>
          <select
            name="gender"
            value={profile.gender || ''}
            onChange={onChange}
            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 text-gray-900 ${
              errors.gender ? 'border-red-300' : ''
            }`}
          >
            <option value="" className="text-gray-500">Select gender</option>
            <option value="male" className="text-gray-900">Male</option>
            <option value="female" className="text-gray-900">Female</option>
            <option value="other" className="text-gray-900">Other</option>
          </select>
          {errors.gender && <p className="text-xs text-red-600 mt-1">{errors.gender}</p>}
        </div>
      </div>

      {profile.gender === 'other' && (
        <div>
          <label className="block text-xs font-medium text-gray-700">Specify Gender</label>
          <input
            type="text"
            name="genderOther"
            value={profile.genderOther || ''}
            onChange={onChange}
            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 ${
              errors.genderOther ? 'border-red-300' : ''
            }`}
          />
          {errors.genderOther && <p className="text-xs text-red-600 mt-1">{errors.genderOther}</p>}
        </div>
      )}

      <div className="relative">
        <label className="block text-xs font-medium text-gray-700">Ethnicity</label>
        <select
          name="ethnicity"
          value={profile.ethnicity || ''}
          onChange={onChange}
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 text-gray-900 ${
            errors.ethnicity ? 'border-red-300' : ''
          }`}
        >
          <option value="" className="text-gray-500">Select ethnicity</option>
          {ETHNICITY_OPTIONS.map(option => (
            <option key={option} value={option} className="text-gray-900">
              {option}
            </option>
          ))}
        </select>
        {errors.ethnicity && <p className="text-xs text-red-600 mt-1">{errors.ethnicity}</p>}
      </div>

      {profile.ethnicity === 'Other' && (
        <div>
          <label className="block text-xs font-medium text-gray-700">Specify Ethnicity</label>
          <input
            type="text"
            name="ethnicityOther"
            value={profile.ethnicityOther || ''}
            onChange={onChange}
            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 ${
              errors.ethnicityOther ? 'border-red-300' : ''
            }`}
          />
          {errors.ethnicityOther && <p className="text-xs text-red-600 mt-1">{errors.ethnicityOther}</p>}
        </div>
      )}

      <div className="relative">
        <label className="block text-xs font-medium text-gray-700">Disability</label>
        <select
          name="disability"
          value={profile.disability || ''}
          onChange={onChange}
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 text-gray-900 ${
            errors.disability ? 'border-red-300' : ''
          }`}
        >
          <option value="" className="text-gray-500">Select disability</option>
          {DISABILITY_OPTIONS.map(option => (
            <option key={option} value={option} className="text-gray-900">
              {option}
            </option>
          ))}
        </select>
        {errors.disability && <p className="text-xs text-red-600 mt-1">{errors.disability}</p>}
      </div>

      {profile.disability === 'Other' && (
        <div>
          <label className="block text-xs font-medium text-gray-700">Specify Disability</label>
          <input
            type="text"
            name="disabilityOther"
            value={profile.disabilityOther || ''}
            onChange={onChange}
            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 ${
              errors.disabilityOther ? 'border-red-300' : ''
            }`}
          />
          {errors.disabilityOther && <p className="text-xs text-red-600 mt-1">{errors.disabilityOther}</p>}
        </div>
      )}

      <div>
        <label className="block text-xs font-medium text-gray-700 mb-2">Interests</label>
        <div className="grid grid-cols-2 gap-2">
          {INTERESTS.map(interest => (
            <div key={interest} className="flex items-center">
              <input
                type="checkbox"
                id={`interest-${interest}`}
                checked={profile.interests?.includes(interest) || false}
                onChange={() => handleInterestToggle(interest)}
                className="h-3 w-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label htmlFor={`interest-${interest}`} className="ml-2 text-xs text-gray-700">
                {interest}
              </label>
            </div>
          ))}
        </div>
        {errors.interests && <p className="text-xs text-red-600 mt-1">{errors.interests}</p>}
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-700">Education Status</label>
        <select
          name="educationStatus"
          value={profile.educationStatus || ''}
          onChange={onChange}
          className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 text-gray-900 ${
            errors.educationStatus ? 'border-red-300' : ''
          }`}
        >
          <option value="" className="text-gray-500">Select education status</option>
          {EDUCATION_STATUS.map(option => (
            <option key={option} value={option} className="text-gray-900">
              {option}
            </option>
          ))}
        </select>
        {errors.educationStatus && <p className="text-xs text-red-600 mt-1">{errors.educationStatus}</p>}
      </div>

      <div className="space-y-3 mt-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">EHCP (Education, Health and Care Plan)</label>
          <div className="flex space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="ehcp"
                value="yes"
                checked={profile.ehcp === 'yes'}
                onChange={onChange}
                className={`h-3 w-3 text-blue-600 focus:ring-blue-500 ${
                  errors.ehcp ? 'border-red-300' : ''
                }`}
              />
              <span className="ml-2 text-xs text-gray-700">Yes</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="ehcp"
                value="no"
                checked={profile.ehcp === 'no'}
                onChange={onChange}
                className={`h-3 w-3 text-blue-600 focus:ring-blue-500 ${
                  errors.ehcp ? 'border-red-300' : ''
                }`}
              />
              <span className="ml-2 text-xs text-gray-700">No</span>
            </label>
          </div>
          {errors.ehcp && <p className="text-xs text-red-600 mt-1">{errors.ehcp}</p>}
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">DLA (Disability Living Allowance)</label>
          <div className="flex space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="dla"
                value="yes"
                checked={profile.dla === 'yes'}
                onChange={onChange}
                className={`h-3 w-3 text-blue-600 focus:ring-blue-500 ${
                  errors.dla ? 'border-red-300' : ''
                }`}
              />
              <span className="ml-2 text-xs text-gray-700">Yes</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="dla"
                value="no"
                checked={profile.dla === 'no'}
                onChange={onChange}
                className={`h-3 w-3 text-blue-600 focus:ring-blue-500 ${
                  errors.dla ? 'border-red-300' : ''
                }`}
              />
              <span className="ml-2 text-xs text-gray-700">No</span>
            </label>
          </div>
          {errors.dla && <p className="text-xs text-red-600 mt-1">{errors.dla}</p>}
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">PIP (Personal Independence Payment)</label>
          <div className="flex space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="pip"
                value="yes"
                checked={profile.pip === 'yes'}
                onChange={onChange}
                className={`h-3 w-3 text-blue-600 focus:ring-blue-500 ${
                  errors.pip ? 'border-red-300' : ''
                }`}
              />
              <span className="ml-2 text-xs text-gray-700">Yes</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="pip"
                value="no"
                checked={profile.pip === 'no'}
                onChange={onChange}
                className={`h-3 w-3 text-blue-600 focus:ring-blue-500 ${
                  errors.pip ? 'border-red-300' : ''
                }`}
              />
              <span className="ml-2 text-xs text-gray-700">No</span>
            </label>
          </div>
          {errors.pip && <p className="text-xs text-red-600 mt-1">{errors.pip}</p>}
        </div>
      </div>
    </div>
  );
};

export default ProfileForm; 